import React from 'react';
import styles from './BrandButton.module.scss';
import { useMatch, useNavigate } from 'react-router-dom';

export interface BrandButtonProps {
  icon: string;
}

export const BrandButton = ({
  icon
}: BrandButtonProps): React.ReactElement<BrandButtonProps> => {
  const navigate = useNavigate();
  const match = useMatch('/');

  // check match to avoid redirecting if current route is already the root
  const onClick = () => !match && navigate('/');

  return (
    <button className={styles.brandButton} onClick={onClick} aria-label="Home">
      <img src={icon} alt="Home" />
    </button>
  );
};
